import React, { 
    Fragment
} from 'react';
import { IconTextTopDown } from '.';
import oops50Icon from "../images/icons/oops50.svg";
import styled from "styled-components";

const Wrapper = styled.div`
    text-align: center;
    margin-top: 116px;

    ${props => props.theme.mediaQueries.medium}{
        margin-top: 176px;
    };
`

const ErrorMessageForModals = ({
    headerText,
    paragraphText
}) => {
    return (
        <Wrapper>
            <IconTextTopDown 
                widthIcon="50px"
                heightIcon="50px"
                fontSizeHeader="1.83rem"
                fontSizeHeaderMediaQueriesMedium="1.7rem"
                lineHeightHeader="26px"
                fontSizeP="1.17rem"
                fontSizePMediaQueriesMedium="0.8rem"
                marginTopIconMediaQueriesMedium="0"
                marginTopHeader="16px"
                marginTopHeaderMediaQueriesMedium="26px"
                marginTopP="8px"
                marginTopPMediaQueriesMedium="16px"
                backgroundImg={oops50Icon}
                headerText={headerText || "OOPS!"}
                paragraphText={paragraphText || "Noget gik galt. Prøv igen."}
            />
        </Wrapper>
    )
}

export default ErrorMessageForModals;